"use client";

import { Component, type ReactNode } from "react";
import { clientLog } from "@/lib/observe/client";
import { ErrorScreen } from "@/components/ErrorScreen";

type Props = { children: ReactNode };
type State = { hasError: boolean };

export default class RootErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: { componentStack?: string | null }) {
    void clientLog.error({
      kind: "react_error_boundary",
      error,
      payload: { componentStack: info.componentStack ?? null },
      route: typeof window !== "undefined" ? window.location.pathname : undefined,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorScreen retry={() => window.location.reload()} />
      );
    }
    return this.props.children;
  }
}
